import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'

// presentational component
import UI from './UI'

export default compose(
  withRedux // for setting error state
)(UI)
